var $2b35eba0f962bae7$exports = {};
$2b35eba0f962bae7$exports = {
    "collectionLabel": `Suggesties`
};


export {$2b35eba0f962bae7$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
